/**
該模組是用於定義action對象中type類型的常量值,目的只有一個：便於管理的同時防止工程師單字寫錯
 * 
 */

export const INCREMENT = "increment";
export const DECREMENT = "decrement";
export const ADD_PERSON = "add_person";
